import {getQueryParams} from '@wix/music-shared/dist/src/utils/queryParams/queryParams';

export function getAlbumId() {
  const hash = location.hash;
  const search = hash.includes('?') ? hash.slice(hash.indexOf('?')) : '';
  return getQueryParams(search).albumId;
}
